import gql from 'graphql-tag'

export const fetchContactsCategory = id => {
	return {
		query: gql`
			query ($id: bigint!) {
				category: contacts_categories_by_pk(id: $id) {
					category_name
					country_id
					order
				}
			}
		`,
		variables: { id }
	}
}
